/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetHealthcareFacilityDataDto
 */
export interface GetHealthcareFacilityDataDto {
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    healthcareFacilityId: string;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    nameDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    namePsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    nipPsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    regon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    regonPsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    entryContentPsychological?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    entryContentDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    p1WorkplaceOidExt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    openMondayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    closeMondayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    openTuesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    closeTuesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    openWednesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    closeWednesdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    openThursdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    closeThursdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    openFridayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    closeFridayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    openSaturdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    closeSaturdayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    openSundayTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDataDto
     */
    closeSundayTime?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetHealthcareFacilityDataDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetHealthcareFacilityDataDto
     */
    validTo?: Date | null;
}

/**
 * Check if a given object implements the GetHealthcareFacilityDataDto interface.
 */
export function instanceOfGetHealthcareFacilityDataDto(value: object): value is GetHealthcareFacilityDataDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('healthcareFacilityId' in value) || value['healthcareFacilityId'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    return true;
}

export function GetHealthcareFacilityDataDtoFromJSON(json: any): GetHealthcareFacilityDataDto {
    return GetHealthcareFacilityDataDtoFromJSONTyped(json, false);
}

export function GetHealthcareFacilityDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHealthcareFacilityDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'healthcareFacilityId': json['healthcareFacilityId'],
        'nameDoctor': json['nameDoctor'] == null ? undefined : json['nameDoctor'],
        'namePsychological': json['namePsychological'] == null ? undefined : json['namePsychological'],
        'city': json['city'] == null ? undefined : json['city'],
        'address': json['address'] == null ? undefined : json['address'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'nipPsychological': json['nipPsychological'] == null ? undefined : json['nipPsychological'],
        'regon': json['regon'] == null ? undefined : json['regon'],
        'regonPsychological': json['regonPsychological'] == null ? undefined : json['regonPsychological'],
        'entryContentPsychological': json['entryContentPsychological'] == null ? undefined : json['entryContentPsychological'],
        'entryContentDoctor': json['entryContentDoctor'] == null ? undefined : json['entryContentDoctor'],
        'p1WorkplaceOidExt': json['p1WorkplaceOidExt'] == null ? undefined : json['p1WorkplaceOidExt'],
        'openMondayTime': json['openMondayTime'] == null ? undefined : json['openMondayTime'],
        'closeMondayTime': json['closeMondayTime'] == null ? undefined : json['closeMondayTime'],
        'openTuesdayTime': json['openTuesdayTime'] == null ? undefined : json['openTuesdayTime'],
        'closeTuesdayTime': json['closeTuesdayTime'] == null ? undefined : json['closeTuesdayTime'],
        'openWednesdayTime': json['openWednesdayTime'] == null ? undefined : json['openWednesdayTime'],
        'closeWednesdayTime': json['closeWednesdayTime'] == null ? undefined : json['closeWednesdayTime'],
        'openThursdayTime': json['openThursdayTime'] == null ? undefined : json['openThursdayTime'],
        'closeThursdayTime': json['closeThursdayTime'] == null ? undefined : json['closeThursdayTime'],
        'openFridayTime': json['openFridayTime'] == null ? undefined : json['openFridayTime'],
        'closeFridayTime': json['closeFridayTime'] == null ? undefined : json['closeFridayTime'],
        'openSaturdayTime': json['openSaturdayTime'] == null ? undefined : json['openSaturdayTime'],
        'closeSaturdayTime': json['closeSaturdayTime'] == null ? undefined : json['closeSaturdayTime'],
        'openSundayTime': json['openSundayTime'] == null ? undefined : json['openSundayTime'],
        'closeSundayTime': json['closeSundayTime'] == null ? undefined : json['closeSundayTime'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
    };
}

export function GetHealthcareFacilityDataDtoToJSON(value?: GetHealthcareFacilityDataDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'healthcareFacilityId': value['healthcareFacilityId'],
        'nameDoctor': value['nameDoctor'],
        'namePsychological': value['namePsychological'],
        'city': value['city'],
        'address': value['address'],
        'nip': value['nip'],
        'nipPsychological': value['nipPsychological'],
        'regon': value['regon'],
        'regonPsychological': value['regonPsychological'],
        'entryContentPsychological': value['entryContentPsychological'],
        'entryContentDoctor': value['entryContentDoctor'],
        'p1WorkplaceOidExt': value['p1WorkplaceOidExt'],
        'openMondayTime': value['openMondayTime'],
        'closeMondayTime': value['closeMondayTime'],
        'openTuesdayTime': value['openTuesdayTime'],
        'closeTuesdayTime': value['closeTuesdayTime'],
        'openWednesdayTime': value['openWednesdayTime'],
        'closeWednesdayTime': value['closeWednesdayTime'],
        'openThursdayTime': value['openThursdayTime'],
        'closeThursdayTime': value['closeThursdayTime'],
        'openFridayTime': value['openFridayTime'],
        'closeFridayTime': value['closeFridayTime'],
        'openSaturdayTime': value['openSaturdayTime'],
        'closeSaturdayTime': value['closeSaturdayTime'],
        'openSundayTime': value['openSundayTime'],
        'closeSundayTime': value['closeSundayTime'],
        'validFrom': ((value['validFrom']).toISOString()),
        'validTo': value['validTo'] == null ? undefined : ((value['validTo'] as any).toISOString()),
    };
}

